import TargetLocations from './TargetLocations.page';

export default TargetLocations;